import { render, staticRenderFns } from "./FamilyViewerComponent.vue?vue&type=template&id=232119e9&scoped=true&"
import script from "./FamilyViewerComponent.vue?vue&type=script&lang=js&"
export * from "./FamilyViewerComponent.vue?vue&type=script&lang=js&"
import style0 from "./FamilyViewerComponent.vue?vue&type=style&index=0&id=232119e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232119e9",
  null
  
)

export default component.exports